import './style.css'
import HeroSectionOne from '../../components/HeroSectionOne/HeroSectionOne'
import HeroSectionSecond from '../../components/HeroSectionSecond/HeroSectionSecond'
import HeroBanner from '../../components/HeroBanner/BuySaddle'
import PartnerHeroBanner from '../../components/HeroBanner/PartnersPage/HeroBanner'
import PartnerBanner from '../../components/HeroBanner/PartnersPage/Banner'
import MainLayout from '../../components/Layout'

function BannerSection() {
  return (
    <MainLayout>
        <div className="mx-auto px-5 sm:px-0">
          <div className="flex flex-col items-start">
            <h2 className="events h-[50px] sm:h-auto">
              Banners
            </h2>
          </div>
          <div className="mx-auto grid max-w-full divide-y divide-neutral-200">
            <p className="change-font-family text-[#2B364B] text-xl font-bold tracking-tight md:text-2xl">
              Landing Banners
            </p>
            <HeroSectionOne type={'LANDING'} listSlotIndex={0} />
            <HeroSectionSecond type={'LANDING'} listSlotIndex={1} />
          </div>
          <div className="mx-auto mt-8 grid max-w-full divide-y divide-neutral-200">
            <p className="change-font-family mt-5 text-[#2B364B] text-xl font-bold tracking-tight md:text-2xl">
              Custom Saddle Tree
            </p>
            <HeroSectionOne
              type={'CUSTOM_SADDLE_TREE'}
              imageOnly
              listSlotIndex={0}
            />
          </div>
          <div className="mx-auto mt-8 grid max-w-full divide-y divide-neutral-200">
            <p className="change-font-family mt-5  text-[#2B364B] text-xl font-bold tracking-tight md:text-2xl">
              Cactus Banners
            </p>
            <HeroSectionSecond type={'CACTUS'} listSlotIndex={0} />
            <HeroSectionOne type={'CACTUS'} listSlotIndex={1} />
          </div>
          <div className="mx-auto mt-8 grid max-w-full divide-y divide-neutral-200">
            <p className="change-font-family mt-5  text-[#2B364B] text-xl font-bold tracking-tight md:text-2xl">
              Buy Saddles Banners
            </p>
            <HeroBanner type={'BUY_SADDLE'} />
            <HeroSectionSecond type={'BUY_SADDLE'} listSlotIndex={0} />
            <HeroSectionOne type={'BUY_SADDLE'} listSlotIndex={1} />
          </div>

          <div className="mx-auto mt-8 grid max-w-full divide-y divide-neutral-200">
            <p className="change-font-family mt-5  text-[#2B364B] text-xl font-bold tracking-tight md:text-2xl">
              Partner's Banners
            </p>
            <PartnerHeroBanner />
            <PartnerBanner />
          </div>
        </div>
    </MainLayout>
  )
}

export default BannerSection
